import { Box, css } from '@mui/material'

import { useMQ } from '../hooks/useMQ'
import { CONFIG } from '../utils/config'
import { HumaScrollAnimation } from './HumaScrollAnimation'
import {
  JoinTheCommunityDiscord,
  JoinTheCommunityLinkedIn,
  JoinTheCommunityX,
  JoinTheCommunityYoutube,
} from './icons'
import { Title } from './Title'

function SocialButton({
  link,
  icon,
}: {
  link: string
  icon: React.ReactElement
}) {
  const { isXsSize } = useMQ()

  const styles = {
    button: css`
      box-sizing: border-box;
      border-radius: 100%;
      padding: 10px;
      background: rgba(255, 255, 255, 0.1);
      display: flex;
      width: ${isXsSize ? '56px' : '80px'};
      height: ${isXsSize ? '56px' : '80px'};
      position: relative;
      margin: 10px;
      z-index: 2;
      align-items: center;
      justify-content: center;

      svg {
        width: ${isXsSize ? '26px' : '36px'};
      }

      &:hover {
        background: linear-gradient(180deg, #999 0%, #fff 100%);
        backdrop-filter: blur(25px);

        svg {
          path {
            fill: #000;
          }
        }
      }
    `,
  }

  return (
    <HumaScrollAnimation>
      <Box component='a' href={link} css={styles.button} target='_blank'>
        {icon}
      </Box>
    </HumaScrollAnimation>
  )
}

export function JoinTheCommunity() {
  const { isXsSize } = useMQ()

  const styles = {
    wrapper: css`
      position: relative;
      color: white;
      text-align: center;
      margin-bottom: 30px;
      margin-top: ${isXsSize ? '72px' : '160px'};
    `,
    secondaryTitle: css`
      z-index: 1;
      position: relative;
      margin-top: ${isXsSize ? '-20px' : '-40px'};
      margin-bottom: 30px;
      padding: 0 20px;
      color: #d3ccdd;
      font-size: 18px;
      font-weight: 400;
      line-height: 150%;
      letter-spacing: 0.15px;
    `,
    communityContainer: css`
      z-index: 1;
      position: relative;
      padding: 0 20px;
      max-width: 650px;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: ${isXsSize ? 'space-evenly' : 'space-between'};
    `,
  }

  return (
    <Box css={styles.wrapper}>
      <Box zIndex={2} position={'relative'}>
        <HumaScrollAnimation>
          <Title title='Join The Payfi Movement' />
        </HumaScrollAnimation>
        <Box css={styles.communityContainer}>
          <SocialButton
            link={CONFIG.twitterLink}
            icon={<JoinTheCommunityX />}
          />
          <SocialButton
            link={CONFIG.discordLink}
            icon={<JoinTheCommunityDiscord />}
          />
          <SocialButton
            link={CONFIG.youtubeLink}
            icon={<JoinTheCommunityYoutube />}
          />
          <SocialButton
            link={CONFIG.linkedInLink}
            icon={<JoinTheCommunityLinkedIn />}
          />
        </Box>
      </Box>
    </Box>
  )
}
